import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { ShowHide } from "components/layout";
import { Tooltip } from "components/tooltip";
import { isCappedEndedPeriod } from "./kpiPeriodShading";
import { formatPeriodHeaderTooltip } from "./kpiPeriodWindow";
import "./EarnedRecognition.css";

// Joins the small-operator note onto the period tooltip, matching how that tooltip separates its
// own parts.
const tooltipSeparator = " · ";

// A period column header for the KPI grids: the ISO period number with its week range beneath,
// wrapped in a tooltip giving the period's calendar dates and, for a capped period, the
// small-operator explanation — one tooltip for the whole header rather than a second on the marker.
//
// The small-operator slot renders on every column whenever the dashboard holds any marked period,
// hidden where the period is not marked, so every header keeps the same height.
//
// ListingTable.formatHeaders reads element.key off the header element it is given, so callers must
// put the key on this component rather than on anything inside it.
//
// The two KPI dashboards describe the small-operator provision against different measures, so the
// tooltip text is supplied by the caller.
export function ErPeriodHeader(
    {
        period,
        showCappedSlot = false,
        cappedMarkerTooltip = ""
    }
) {
    const isCapped = isCappedEndedPeriod(period);

    let tooltipContent = formatPeriodHeaderTooltip(period.isoYear, period.isoPeriod);
    if (isCapped) {
        tooltipContent = `${tooltipContent}${tooltipSeparator}${cappedMarkerTooltip}`;
    }

    return (
        <Tooltip content={tooltipContent}>
            <div className="er-kpi-period-header">
                <div className="er-kpi-period-number">{period.isoPeriod}</div>
                <div className="er-kpi-period-weeks">{`${period.isoWeekStart}–${period.isoWeekEnd}`}</div>
                <ShowHide
                    evaluator={showCappedSlot}
                    show={(
                        <span className={classNames("er-kpi-period-capped", { "er-kpi-period-capped-hidden": !isCapped })}>
                            S
                        </span>
                    )}
                />
            </div>
        </Tooltip>
    );
}

ErPeriodHeader.propTypes = {
    period: PropTypes.object.isRequired,
    showCappedSlot: PropTypes.bool,
    cappedMarkerTooltip: PropTypes.string
};
